const NotFound = () => {
    return (
      <div className="notfound">
        404 <span>Error</span>
        <p>승인되지 않은 경로입니다. 경로를 다시 확인하시기 바랍니다.</p>
      </div>
    );
  };
  
  export default NotFound;